import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ShkDate } from 'shk-date';
import { ChecklistExecutionMapService } from './service/checklist-execution-map.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RouterModule } from '@angular/router';
import { GlobalService } from 'src/app/services/global/global.service';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

interface TimeSlot {
	[time: string]: {
		checklists: string[];
		totalMinutes: number;
	};
}

export interface checklistMap {
	[day: string]: TimeSlot;
}

@Component({
	selector: 'app-checklist-execution-map',
	standalone: true,
	imports: [CommonModule, RouterModule, SvgGearsModule, FontAwesomeModule],
	templateUrl: './checklist-execution-map.component.html',
	styleUrl: './checklist-execution-map.component.scss',
})
export class ChecklistExecutionMapComponent implements OnInit {
	protected Object: ObjectConstructor;

	icons = {
		faMagnifyingGlass: faMagnifyingGlass,
	};

	labels: LabelsInterface = {
		lbl_calendario_checklists: '',
		lbl_hora_dia: 'Hour/Day',
		lbl_rep_total_das_horas: 'Total of hours',
		lbl_rep_total_dos_dias: 'Total of days',
		lbl_geral_legenda: 'Legend',
		lbl_geral_executado_sucesso: 'Succesful executed',
		lbl_chamado_tarefa_em_execucao: 'Running',
		lbl_geral_falhou: 'Failed',
		lbl_projetos_nao_iniciado: 'Not started',
		lbl_geral_ano: 'Year',
		lbl_geral_mes: 'Month',
		lbl_edocs_carregando: 'Loading',
	};

	constructor(
		private LabelsService: LabelsService,
		private ChecklistExecutionMapService: ChecklistExecutionMapService
	) {
		this.Object = Object;
	}

	isLoadingCheckListMap = true;
	isLoadingLabels = true;
	isLoadingAvailableFilters = true;

	availableYears: number[] = [];
	availableMonths: { value: number; label: string }[] = [
		{ value: 1, label: 'lbl_geral_janeiro' },
		{ value: 2, label: 'lbl_geral_fevereiro' },
		{ value: 3, label: 'lbl_geral_marco' },
		{ value: 4, label: 'lbl_geral_abril' },
		{ value: 5, label: 'lbl_geral_maio' },
		{ value: 6, label: 'lbl_geral_junho' },
		{ value: 7, label: 'lbl_geral_julho' },
		{ value: 8, label: 'lbl_geral_agosto' },
		{ value: 9, label: 'lbl_geral_setembro' },
		{ value: 10, label: 'lbl_geral_outubro' },
		{ value: 11, label: 'lbl_geral_novembro' },
		{ value: 12, label: 'lbl_geral_dezembro' },
	];

	selectedDate: ShkDate;
	checklistMap: checklistMap;

	ngOnInit(): void {
		this.finishLoading();

		this.LabelsService.getLabels()
			.subscribe({
				next: (labels) => {
					this.labels = labels;
				},
			})
			.add(() => {
				this.isLoadingLabels = false;
			});

		this.selectedDate = new ShkDate();
		this.getChecklistMap();
		for (let year = Number.parseInt(this.selectedDate.year.toString()) + 1; year >= 2000; year--) {
			this.availableYears.push(year);
		}

		this.isLoadingAvailableFilters = false;
	}

	async finishLoading() {
		await this.until(() => this.isLoadingLabels == false && this.isLoadingCheckListMap == false);
	}

	until(conditionFunction: Function) {
		const poll = (resolve) => {
			if (conditionFunction()) resolve();
			else setTimeout(() => poll(resolve), 400);
		};

		return new Promise(poll);
	}

	sumTotalHoursThroughDays(time: string): number {
		const days = this.Object.keys(this.checklistMap);
		let sumOfHours = 0;
		for (const day of days) {
			const dayTime = this.checklistMap[day][time];
			sumOfHours += dayTime.totalMinutes;
		}

		return sumOfHours / 60;
	}

	sumTotalChecklistsInDay(day: string): number {
		const times = this.Object.keys(this.checklistMap[day]);
		let sumOfChecklists = 0;
		for (const time of times) {
			sumOfChecklists += this.checklistMap[day][time].checklists.length;
		}

		return sumOfChecklists;
	}

	sumTotalChecklistInMonth(): number {
		const days = this.Object.keys(this.checklistMap);
		let sumOfChecklists = 0;
		for (const day of days) {
			sumOfChecklists += this.sumTotalChecklistsInDay(day);
		}

		return sumOfChecklists;
	}

	getChecklistMap(): void {
		this.isLoadingCheckListMap = true;
		this.ChecklistExecutionMapService.getChecklistMap(
			Number.parseInt(this.selectedDate.year.toString()),
			Number.parseInt(this.selectedDate.month.toString())
		)
			.subscribe({
				next: (checklistMap: checklistMap) => {
					this.checklistMap = checklistMap;
				},
			})
			.add(() => {
				this.isLoadingCheckListMap = false;
			});
	}
}
